import React from 'react';
import { FadeIn } from './ui';
export const Proof = () => {
  return <section className="py-16 px-6" data-id="element-124">
      <div className="max-w-2xl mx-auto text-center" data-id="element-125">
        <FadeIn data-id="element-126">
          <h2 className="text-2xl md:text-3xl mb-6 text-amber font-serif italic" data-id="element-127">
            What changes in 7 days
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-128">
          <p className="text-lg md:text-xl text-parchment-muted font-light leading-loose" data-id="element-129">
            By night three, the "shuffling" becomes a conditioned reflex.
            Instead of staring at the ceiling for 90 minutes, you'll find
            yourself losing track of the script and waking up to your alarm,
            feeling like you actually inhabited your body all night.
          </p>
        </FadeIn>
      </div>
    </section>;
};